import Info from './info';

const infoConfig = {
  name: 'info',
  class: Info,
  querySelector: {
    enrollBtn: '.enroll-btn',
    enrollDesktopEl: '.info__course-enroll-desktop',
    enrollMobileEl: '.details__enroll-mobile',
  },
  querySelectorAll: {},
  options: {},
};

export default infoConfig;
